import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Lazy load components
const TaxCodeList = lazy(() => import('../Pages/TaxCodeList'));
const TaxCodeAdd = lazy(() => import('../Pages/TaxCodeAdd'));
const TaxCodeEdit = lazy(() => import('../Pages/TaxCodeEdit'));
const TaxCodeView = lazy(() => import('../Pages/TaxCodeView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/taxcode.scss';

function TaxCodeRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/tax-code"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <TaxCodeList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/tax-codes"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <TaxCodeList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/tax-codes/add"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <TaxCodeAdd history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/tax-codes/edit/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <TaxCodeEdit history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/tax-codes/view/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <TaxCodeView history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
    </Switch>
  );
}

// Loading component
function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}

export default TaxCodeRoute;
